import { IntlShape } from '@redbubble/next/intl';
export const asCurrency = (amount: number, intl: IntlShape, currency: string) =>
  intl.formatNumber(amount, {
    currency,
    style: 'currency',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
